// src/config/boxThemes.js
// Named themes for different brand boxes

import { PHARMACY_HALO_COLORS, DOCLINK_COLORS, QUDA_COLORS, MEDIDROP_COLORS, COMMON_COLORS } from './colors'

export const PHBoxTheme = {
  container: {
    backgroundColor: PHARMACY_HALO_COLORS.BLUE,
    border: `2px solid ${PHARMACY_HALO_COLORS.YELLOW}`,
    borderRadius: '8px',
    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
    padding: '16px',
    color: 'white',
    position: 'relative',
    overflow: 'hidden',
  },
  logo: {
    width: '40px',
    height: '40px',
    marginBottom: '12px',
    filter: 'brightness(0) invert(1)', // Makes logo white
  },
  title: {
    color: PHARMACY_HALO_COLORS.YELLOW,
    fontWeight: 'bold',
    marginBottom: '8px',
    fontSize: '1.125rem',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  value: {
    color: 'white',
    fontWeight: 'bold',
    fontSize: '2rem',
    marginBottom: '8px',
  },
  icon: {
    color: PHARMACY_HALO_COLORS.YELLOW,
    fontSize: '1.5rem',
    opacity: 0.8,
  },
  backgroundIcon: {
    position: 'absolute',
    right: '-10px',
    bottom: '-10px',
    fontSize: '4rem',
    color: PHARMACY_HALO_COLORS.YELLOW,
    opacity: 0.1,
    transform: 'rotate(15deg)',
  },
  hover: {
    transform: 'translateY(-2px)',
    boxShadow: '0 10px 25px -3px rgba(0, 0, 0, 0.1)',
    transition: 'all 0.2s ease-in-out',
  }
}

export const DocLinkBoxTheme = {
  container: {
    backgroundColor: DOCLINK_COLORS.DARK_PURPLE,
    border: `2px solid ${DOCLINK_COLORS.LIGHT_PURPLE}`,
    borderRadius: '8px',
    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
    padding: '16px',
    color: 'white',
    position: 'relative',
    overflow: 'hidden',
  },
  logo: {    
    height: '40px',
    marginBottom: '12px',
    filter: 'brightness(0) invert(1)', // Makes logo white
  },
  title: {
    color: DOCLINK_COLORS.LIGHT_PURPLE,
    fontWeight: 'bold',
    marginBottom: '8px',
    fontSize: '1.125rem',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  value: {
    color: 'white',
    fontWeight: 'bold',
    fontSize: '3rem',
    marginBottom: '8px',
  },
  icon: {
    color: DOCLINK_COLORS.LIGHT_PURPLE,
    fontSize: '1.5rem',
    opacity: 0.8,
  },
  backgroundIcon: {
    position: 'absolute',
    right: '-20px',
    bottom: '-60px',
    fontSize: '14rem',
    color: DOCLINK_COLORS.LIGHT_PURPLE,
    opacity: 0.4,
    transform: 'rotate(15deg)',
  },
  hover: {
    transform: 'translateY(-2px)',
    boxShadow: '0 10px 25px -3px rgba(0, 0, 0, 0.1)',
    transition: 'all 0.2s ease-in-out',
  }
}

/** HubMed admin reporting — violet/teal aligned with HubMed nav styling */
export const HubMedBoxTheme = {
  container: {
    backgroundColor: "#4c1d95",
    border: "2px solid #a78bfa",
    borderRadius: "8px",
    boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1)",
    padding: "16px",
    color: "white",
    position: "relative",
    overflow: "hidden",
  },
  logo: {
    height: "40px",
    marginBottom: "12px",
    filter: "brightness(0) invert(1)",
  },
  title: {
    color: "#ddd6fe",
    fontWeight: "bold",
    marginBottom: "8px",
    fontSize: "1.125rem",
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  value: {
    color: "white",
    fontWeight: "bold",
    fontSize: "2.25rem",
    marginBottom: "8px",
  },
  icon: {
    color: "#a78bfa",
    fontSize: "1.5rem",
    opacity: 0.85,
  },
  backgroundIcon: {
    position: "absolute",
    right: "-20px",
    bottom: "-40px",
    fontSize: "10rem",
    color: "#a78bfa",
    opacity: 0.25,
    transform: "rotate(12deg)",
  },
  hover: {
    transform: "translateY(-2px)",
    boxShadow: "0 10px 25px -3px rgba(0, 0, 0, 0.1)",
    transition: "all 0.2s ease-in-out",
  },
};

export const QudaBoxTheme = {
  container: {
    backgroundColor: QUDA_COLORS.TEAL_DARK,
    border: `2px solid ${QUDA_COLORS.TEAL_LIGHT}`,
    borderRadius: '8px',
    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
    padding: '16px',
    color: 'white',
    position: 'relative',
    overflow: 'hidden',
  },
  logo: {    
    height: '40px',
    marginBottom: '12px',
    filter: 'brightness(0) invert(1)', // Makes logo white
  },
  title: {
    color: QUDA_COLORS.TEAL_LIGHT,
    fontWeight: 'bold',
    marginBottom: '8px',
    fontSize: '1.125rem',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  value: {
    color: 'white',
    fontWeight: 'bold',
    fontSize: '3rem',
    marginBottom: '8px',
  },
  icon: {
    color: QUDA_COLORS.TEAL_LIGHT,
    fontSize: '1.5rem',
    opacity: 0.8,
  },
  backgroundIcon: {
    position: 'absolute',
    right: '-20px',
    bottom: '-60px',
    fontSize: '14rem',
    color: QUDA_COLORS.TEAL_LIGHT,
    opacity: 0.4,
    transform: 'rotate(15deg)',
  },
  hover: {
    transform: 'translateY(-2px)',
    boxShadow: '0 10px 25px -3px rgba(0, 0, 0, 0.1)',
    transition: 'all 0.2s ease-in-out',
  }
}

export const MediDropBoxTheme = {
  container: {
    backgroundColor: MEDIDROP_COLORS.ORANGE_DARK,
    border: `2px solid ${MEDIDROP_COLORS.ORANGE_LIGHT}`,
    borderRadius: '8px',
    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
    padding: '16px',
    color: 'white',
    position: 'relative',
    overflow: 'hidden',
  },
  logo: {
    height: '40px',
    marginBottom: '12px',
    filter: 'brightness(0) invert(1)',
  },
  title: {
    color: MEDIDROP_COLORS.ORANGE_LIGHT,
    fontWeight: 'bold',
    marginBottom: '8px',
    fontSize: '1.125rem',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  value: {
    color: 'white',
    fontWeight: 'bold',
    fontSize: '3rem',
    marginBottom: '8px',
  },
  icon: {
    color: MEDIDROP_COLORS.ORANGE_LIGHT,
    fontSize: '1.5rem',
    opacity: 0.9,
  },
  backgroundIcon: {
    position: 'absolute',
    right: '-20px',
    bottom: '-60px',
    fontSize: '14rem',
    color: MEDIDROP_COLORS.ORANGE_LIGHT,
    opacity: 0.3,
    transform: 'rotate(15deg)',
  },
  hover: {
    transform: 'translateY(-2px)',
    boxShadow: '0 10px 25px -3px rgba(0, 0, 0, 0.1)',
    transition: 'all 0.2s ease-in-out',
  },
}

// Helper function to get theme based on brand
export const getBoxTheme = (brand) => {
  switch (brand) {
    case 'doclink':
      return DocLinkBoxTheme
    case 'quda':
      return QudaBoxTheme
    default:
      return PHBoxTheme
  }
}
